var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-sharing"},_vm._l((_vm.socials),function(item,index){return _c('a',{key:index,attrs:{"href":item.link,"aria-label":item.aria,"target":"_blank"}},[_c('i',{class:item.iconClass})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }